import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { DropdownIcons } from '../ag-grid-custom-dropdown/ag-grid-custom-dropdown.component';

@Component({
  selector: 'app-ag-grid-custom-search-dropdown',
  templateUrl: './ag-grid-custom-search-dropdown.component.html',
  styleUrls: ['./ag-grid-custom-search-dropdown.component.scss']
})
export class AgGridCustomSearchDropdownComponent implements ICellEditorAngularComp{
  private _options: any[] = [];
  valueChanged = new EventEmitter<string>();
  public params: any;
  values: any;
  isBlankOption: any;

  @Input() isSearchInput:boolean=false;
  @Input() selectedOption: string; // Stores the selected option
  @Input() id?:string;
  @Input() isRequired:boolean;
  @Input() dropdownLabel:string;
  @Input () optionDisable:number=null;
  highlightedIndex: number = -1
  value: any;
  @Input()
  set options(options: any[]) {
    this._options = options || []; // Ensure options is an array
    this.filteredOptions = [...this._options];
  }

  get options(): any[] {
    return this._options;
  }

  @ViewChild('dropdown') dropdown:NgbDropdown;

  @Output() dropdownValueEmit:EventEmitter<string> = new EventEmitter();
  @Input() selectedId: any;
  @Input() labelName:string;
  searchInput: string = '';
  filteredOptions:any[] = [];;

  selectOption(option){
      this.selectedOption = option?.name;
      this.dropdownValueEmit.emit(option?.id);
      this.selectedId = option?.id;
      this.highlightedIndex = -1; 
      this.dropdown.close();
  }

  cellValueChanged() {
    // Logic on cell value changed
   this.valueChanged.emit(this.value); 
  }

  agInit(params: ICellEditorParams<any> & DropdownIcons): void {
    this.params = params;
    this.isBlankOption = this.params?.isBlankOption??false;
    const valuesOrFunction = params.colDef.cellEditorParams?.values;
    this.values = typeof valuesOrFunction === 'function' ? valuesOrFunction() : valuesOrFunction??[];  
    this.value = this.params.value != undefined ? this.params.value.toString() : '';
  }

  reset(){
    this.selectedOption=null;
    this.selectedId=null;
    this.highlightedIndex = -1; 
  }

  clearSearch() {
    this.searchInput = '';
    this.filteredOptions = [...this._options];
    this.highlightedIndex = -1;
  }

 filterOptions() {
    if (this.searchInput.trim()) {
      this.filteredOptions = this._options?.filter(option => 
        option.name.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    } else {
      this.filteredOptions = [...this._options];
    }
    this.highlightedIndex = -1;
  }

  // #region for highlighted option during up and down key start

  highlightNext() {
    if (this.highlightedIndex < this.filteredOptions.length - 1) {
      this.highlightedIndex++;
    }
  }

  highlightPrevious() {
    if (this.highlightedIndex > 0) {
      this.highlightedIndex--;
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (!this.dropdown.isOpen()) return;
    if (event.key === 'ArrowDown') {
      this.highlightNext();
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.highlightPrevious();
      event.preventDefault();
    } else if (event.key === 'Enter' && this.highlightedIndex >= 0) {
      this.selectOption(this.filteredOptions[this.highlightedIndex]);
      event.preventDefault();
    }
  }

  // #region for highlighted option during up and down key End

  getValue() {
    // if(this.params.colDef.field == "purityPer")
    // {
    //   return (this.value);
    // }
    // else
    // {
      return (this.value != undefined && this.value != null) ?  this.value.toString() : '';
    // }
    
  }

}